angular.module('TetherApp').factory('listenerService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getCampaignListeners = function (data) {
            let uri = '/api/v1/campaign/listeners/' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: data
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let createListener = function (data) {
            return $http.post(
                '/api/v1/listener',
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let updateListener = function (data) {
            // console.log(data.id);
            return $http.put(
                '/api/v1/listener/' + data.id,
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteListener = function (listenerId) {
            let uri = '/api/v1/listener/' + listenerId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getCampaignListeners: getCampaignListeners,
            createListener: createListener,
            updateListener: updateListener,
            deleteListener: deleteListener
        }
    }
]);
